import store from "../../store";
import Errors from "../../Errors";
import CartHelpersMixin from "../../mixins/CartHelpersMixin";
import CartItemHelpersMixin from "../../mixins/CartItemHelpersMixin";

export default {
    mixins: [CartHelpersMixin, CartItemHelpersMixin],

    props: [
        "customerEmail",
        "customerPhone",
        "gateways",
        "defaultAddress",
        "addresses",
        "countries",
        "wallet_amount",
        "isPreorderItems",
    ],

    data() {
        return {
            form: {
                customer_email: this.customerEmail,
                customer_phone: this.customerPhone,
                billing: {},
                shipping: {},
                billingAddressId: null,
                shippingAddressId: null,
                newBillingAddress: false,
                newShippingAddress: false,
                ship_to_a_different_address: false,
                wallet:0,
                check_wallet:'',
                shipping_method: '', // Initialize shipping_method
            },
            states: {
                billing: {},
                shipping: {},
            },
            placingOrder: false,
            errors: new Errors(),
            stripe: null,
            stripeCardElement: null,
            stripeError: null,
            authorizeNetToken: null,
            loadingOrderSummary: false,
        };
    },

    computed: {
        currentCart() {
            return this.isPreorderItems ? (this.preorder || { items: [] }) : (this.cart || { items: [] });
        },
        cartIsNotEmpty() {
            return this.cart && this.cart.items && Object.keys(this.cart.items).length > 0;
        },
        preorderIsNotEmpty() {
            return this.preorder && this.preorder.items && Object.keys(this.preorder.items).length > 0;
        },
        sellIsNotEmpty() {
            return this.sell && this.sell.items && Object.keys(this.sell.items).length > 0;
        },
        cartIsEmpty() {
            return !this.cartIsNotEmpty;
        },
        preorderIsEmpty() {
            return !this.preorderIsNotEmpty;
        },
        sellIsEmpty() {
            return !this.sellIsNotEmpty;
        },

        totalPrice(){
            return this.currentCart.total?.amount ?? 0;
        },
        hasAddress() {
            return Object.keys(this.addresses).length !== 0;
        },
        firstCountry() {
            return Object.keys(this.countries)[0];
        },
        hasBillingStates() {
            return Object.keys(this.states.billing).length !== 0;
        },
        hasShippingStates() {
            return Object.keys(this.states.shipping).length !== 0;
        },
        hasNoPaymentMethod() {
            return Object.keys(this.gateways).length === 0;
        },
        firstPaymentMethod() {
            return Object.keys(this.gateways)[0];
        },
        shouldShowPaymentInstructions() {
            return ["bank_transfer", "check_payment"].includes(
                this.form.payment_method
            );
        },
        paymentInstructions() {
            if (this.shouldShowPaymentInstructions) {
                return this.gateways[this.form.payment_method].instructions;
            }
            return '';
        },
        hasFreeShipping() {
            return this.currentCart.coupon?.free_shipping ?? false;
        },
    },

    mounted(){
        console.log('CheckoutCreate Vue Component Mounted:');
        console.log('Props: isPreorderItems:', this.isPreorderItems);
        console.log('Computed: currentCart:', this.currentCart);
        console.log('Computed: totalPrice:', this.totalPrice);
        console.log('Computed: hasFreeShipping:', this.hasFreeShipping);

        if (this.currentCart.items && Object.keys(this.currentCart.items).length > 0) {
            console.log('First item in currentCart:', this.currentCart.items[Object.keys(this.currentCart.items)[0]]);
        }
    },

    watch: {
        "form.billing.city": function (newCity) { if (newCity) { this.addTaxes(); } },
        "form.shipping.city": function (newCity) { if (newCity) { this.addTaxes(); } },
        "form.billing.zip": function (newZip) { if (newZip) { this.addTaxes(); } },
        "form.shipping.zip": function (newZip) { if (newZip) { this.addTaxes(); } },
        "form.billing.state": function (newState) { if (newState) { this.addTaxes(); } },
        "form.shipping.state": function (newState) { if (newState) { this.addTaxes(); } },

        "form.ship_to_a_different_address": function (newValue) {
            if (newValue && this.form.shippingAddressId) {
                this.form.shipping = this.addresses[this.form.shippingAddressId];
            } else {
                this.form.shipping = {};
                this.resetAddressErrors("shipping");
            }
            this.addTaxes();
        },

        "form.terms_and_conditions": function () {
            this.errors.clear("terms_and_conditions");
        },

        "form.payment_method": function (newPaymentMethod) {
            if (newPaymentMethod === "paypal") {
                this.$nextTick(this.renderPayPalButton);
            }
            if (newPaymentMethod !== "stripe") {
                this.stripeError = "";
            }
            this.resetWallet();
        },
        'currentCart.shippingMethodName': {
            handler(newName) {
                if (newName && this.form.shipping_method === '') {
                    this.form.shipping_method = newName;
                    console.log('Detected shippingMethodName from cart, setting form.shipping_method:', newName);
                }
            },
            immediate: true,
        }
    },

    created() {
        if (this.defaultAddress.address_id) {
            this.form.billingAddressId = this.defaultAddress.address_id;
            this.form.shippingAddressId = this.defaultAddress.address_id;

            this.mergeSavedBillingAddress();
            this.mergeSavedShippingAddress();
        }

        if (!this.hasAddress) {
            this.form.newBillingAddress = true;
            this.form.newShippingAddress = true;
        }

        this.$nextTick(() => {
            this.changePaymentMethod(this.firstPaymentMethod);

            if (this.currentCart.shippingMethodName) {
                this.changeShippingMethod(this.currentCart.shippingMethodName);
                console.log('Setting shipping method from backend cart data:', this.currentCart.shippingMethodName);
            } else {
                console.log('No shipping method found in currentCart, not setting initial form.shipping_method from firstShippingMethod.');
            }

            if (window.Stripe) {
                this.stripe = window.Stripe(FleetCart.stripePublishableKey);
                this.renderStripeElements();
            }
        });
    },

    methods: {
        changeBillingAddress(address) {
            if (
                this.form.newBillingAddress ||
                this.form.billingAddressId === address.id
            ) {
                return;
            }
            this.form.billingAddressId = address.id;
            this.mergeSavedBillingAddress();
        },

        addNewBillingAddress() {
            this.resetAddressErrors("billing");
            this.form.billing = {};
            this.form.newBillingAddress = !this.form.newBillingAddress;
            if (!this.form.newBillingAddress) {
                this.mergeSavedBillingAddress();
            }
        },

        changeShippingAddress(address) {
            if (
                this.form.newShippingAddress ||
                this.form.shippingAddressId === address.id
            ) {
                return;
            }
            this.form.shippingAddressId = address.id;
            this.mergeSavedShippingAddress();
        },

        addNewShippingAddress() {
            this.resetAddressErrors("shipping");
            this.form.shipping = {};
            this.form.newShippingAddress = !this.form.newShippingAddress;
            if (!this.form.newShippingAddress) {
                this.mergeSavedShippingAddress();
            }
        },

        resetAddressErrors(addressType) {
            Object.keys(this.errors.errors).map((key) => {
                key.indexOf(addressType) !== -1 && this.errors.clear(key);
            });
        },

        mergeSavedBillingAddress() {
            this.resetAddressErrors("billing");
            if (!this.form.newBillingAddress && this.form.billingAddressId) {
                this.form.billing = this.addresses[this.form.billingAddressId];
            }
        },

        mergeSavedShippingAddress() {
            this.resetAddressErrors("shipping");
            if (
                this.form.ship_to_a_different_address &&
                !this.form.newShippingAddress &&
                this.form.shippingAddressId
            ) {
                this.form.shipping = this.addresses[this.form.shippingAddressId];
            }
        },

        changeBillingCity(city) { this.$set(this.form.billing, "city", city); },
        changeShippingCity(city) { this.$set(this.form.shipping, "city", city); },
        changeBillingZip(zip) { this.$set(this.form.billing, "zip", zip); },
        changeShippingZip(zip) { this.$set(this.form.shipping, "zip", zip); },

        changeBillingCountry(country) {
            this.$set(this.form.billing, "country", country);
            if (country === "") {
                this.form.billing.state = "";
                this.states.billing = {};
                return;
            }
            this.fetchStates(country, (response) => {
                this.$set(this.states, "billing", response.data);
                this.$set(this.form.billing, "state", "");
            });
        },

        changeShippingCountry(country) {
            this.$set(this.form.shipping, "country", country);
            if (country === "") {
                this.form.shipping.state = "";
                this.states.shipping = {};
                return;
            }
            this.fetchStates(country, (response) => {
                this.$set(this.states, "shipping", response.data);
                this.$set(this.form.shipping, "state", "");
            });
        },

        fetchStates(country, callback) {
            axios.get(route("countries.states.index", { code: country }))
                .then(callback);
        },

        changeBillingState(state) { this.$set(this.form.billing, "state", state); },
        changeShippingState(state) { this.$set(this.form.shipping, "state", state); },

        changePaymentMethod(paymentMethod) { this.$set(this.form, "payment_method", paymentMethod); },

        changeShippingMethod(shippingMethodName) {
            this.$set(this.form, "shipping_method", shippingMethodName);
        },

        async addTaxes() {
            this.loadingOrderSummary = true;
            this.resetWallet();
            try {
                const taxesRoute = this.isPreorderItems ? 'preorder.taxes.store' : 'cart.taxes.store';
                console.log('Attempting to add taxes to route:', taxesRoute);

                const response = await axios.post(
                    route(taxesRoute, {
                        ...(this.currentCart.coupon && this.currentCart.coupon.code && {
                            coupon_code: this.currentCart.coupon.code,
                        }),
                    }),
                    this.form
                );
                console.log('addTaxes: Axios response received:', response); // Log the full response

                if (response && response.data) { // Ensure response and response.data exist
                    if (this.isPreorderItems) {
                        store.updatePreorderCart(response.data);
                    } else {
                        store.updateCart(response.data);
                    }
                } else {
                    console.error('addTaxes: Response or response.data is undefined.', response);
                    this.$notify('An unexpected response was received when calculating taxes.');
                }
            } catch (error) {
                console.error('addTaxes: Error caught:', error); // Log the full error object
                if (error.response && error.response.data && error.response.data.message) {
                    this.$notify(error.response.data.message);
                } else {
                    this.$notify('An unknown error occurred while adding taxes.');
                }
            } finally {
                this.loadingOrderSummary = false;
            }
        },

        updateCart(item, qty) {
            this.loadingOrderSummary = true;
            this.resetWallet();

            const storeModule = item.product?.is_preorder ? 'preorder' : 'cart';
            const routeName = item.product?.is_preorder ? 'preorder.items.update' : 'cart.items.update';

            axios.put(
                route(routeName, {
                    id: item.id,
                    ...(this.currentCart.coupon?.code && {
                        coupon_code: this.currentCart.coupon.code,
                    }),
                }),
                { qty: qty || 1, }
            )
            .then((response) => {
                if (response && response.data) {
                    if (storeModule === 'preorder') {
                        store.updatePreorderCart(response.data);
                    } else {
                        store.updateCart(response.data);
                    }
                } else {
                    console.error('updateCart: Response or response.data is undefined.', response);
                    this.$notify('An unexpected response was received when updating cart.');
                }
            })
            .catch((error) => {
                console.error('updateCart: Error caught:', error);
                if (error.response && error.response.data && error.response.data.cart) { // Check for .cart in error response
                    if (storeModule === 'preorder') {
                         store.updatePreorderCart(error.response.data.preorder); // Update specific cart
                    } else {
                         store.updateCart(error.response.data.cart); // Update specific cart
                    }
                }

                if (error.response && error.response.data && error.response.data.message) {
                    this.$notify(error.response.data.message);
                } else {
                    this.$notify('An unknown error occurred while updating cart.');
                }
            })
            .finally(() => {
                this.loadingOrderSummary = false;
            });
        },

        removeCartItem(item) {
            this.loadingOrderSummary = true;
            this.resetWallet();

            const storeModule = item.product?.is_preorder ? 'preorder' : 'cart';
            const routeName = item.product?.is_preorder ? 'preorder.items.destroy' : 'cart.items.destroy';

            axios.delete(
                route(routeName, {
                    id: item.id,
                    ...(this.currentCart.coupon?.code && {
                        coupon_code: this.currentCart.coupon.code,
                    }),
                })
            )
            .then((response) => {
                if (response && response.data) {
                    if (storeModule === 'preorder') {
                        store.updatePreorderCart(response.data);
                    } else {
                        store.updateCart(response.data);
                    }
                } else {
                    console.error('removeCartItem: Response or response.data is undefined.', response);
                    this.$notify('An unexpected response was received when removing cart item.');
                }
            })
            .catch((error) => {
                console.error('removeCartItem: Error caught:', error);
                if (error.response && error.response.data && error.response.data.message) {
                    this.$notify(error.response.data.message);
                } else {
                    this.$notify('An unknown error occurred while removing cart item.');
                }
            })
            .finally(() => {
                this.loadingOrderSummary = false;
            });
        },

        placeOrder() {
            if (!this.form.terms_and_conditions || this.placingOrder) {
                return;
            }

            console.log('Form data for order before sending:', this.form);

            this.placingOrder = true;

            axios.post(
                route("checkout.store", {
                    ...(this.currentCart.coupon?.code && {
                        coupon_code: this.currentCart.coupon.code,
                    }),
                }),
                {
                    ...this.form,
                    ship_to_a_different_address: +this.form.ship_to_a_different_address,
                }
            )
            .then(({ data }) => {
                console.log('Order success data', data);
                if (data.redirectUrl) {
                    window.location.href = data.redirectUrl;
                } else if (this.form.payment_method === "phonepe") {
                    if(!data.success){
                        this.$notify('Something wrong, please try again');
                    }else{
                        window.location.href = data.data.instrumentResponse.redirectInfo.url;
                    }
                } else if (this.form.payment_method === "stripe") {
                    this.confirmStripePayment(data);
                } else if (this.form.payment_method === "paytm") {
                    this.confirmPaytmPayment(data);
                } else if (this.form.payment_method === "razorpay") {
                    this.confirmRazorpayPayment(data);
                } else if (this.form.payment_method === "paystack") {
                    this.confirmPaystackPayment(data);
                } else if (this.form.payment_method === "authorizenet") {
                    this.confirmAuthorizeNetPayment(data);
                } else if (this.form.payment_method === "flutterwave") {
                    this.confirmFlutterWavePayment(data);
                } else if (this.form.payment_method === "mercadopago") {
                    this.confirmMercadoPagoPayment(data);
                } else {
                    this.confirmOrder(
                        data.orderId,
                        this.form.payment_method
                    );
                }
            })
            .catch((error) => { // Use error directly for consistency
                console.error('placeOrder: Error caught:', error);
                if (error.response && error.response.status === 422) {
                    this.errors.record(error.response.data.errors);
                }
                this.$notify(error.response?.data?.message || 'An error occurred while placing order.');
                this.placingOrder = false;
            });
        },

        confirmOrder(orderId, paymentMethod, params = {}) {
            axios.get(
                route("checkout.complete.store", {
                    orderId,
                    paymentMethod,
                    ...params,
                })
            )
            .then(() => {
                window.location.href = route("checkout.complete.show");
            })
            .catch((error) => {
                console.error('confirmOrder: Error caught:', error);
                this.placingOrder = false;
                this.loadingOrderSummary = false;
                this.deleteOrder(orderId);
                this.$notify(error.response?.data?.message || 'Failed to confirm order.');
            });
        },

        deleteOrder(orderId) {
            if (!orderId) {
                return;
            }
            axios.get(route("checkout.payment_canceled.store", { orderId }))
                .then((response) => {
                    this.$notify(response.data.message || 'Order cancellation processed.');
                })
                .catch((error) => {
                    console.error('deleteOrder: Error caught:', error);
                    this.$notify(error.response?.data?.message || 'Failed to cancel order.');
                });
        },

        placePreOrder() {
            if (!this.form.terms_and_conditions || this.placingOrder) {
                return;
            }

            console.log('Form data before sending (Preorder):', this.form);

            this.placingOrder = true;

            axios.post(
                route("preorder.checkout.store", {
                    ...(this.currentCart.coupon?.code && {
                        coupon_code: this.currentCart.coupon.code,
                    }),
                }),
                {
                    ...this.form,
                    ship_to_a_different_address: +this.form.ship_to_a_different_address,
                }
            )
            .then(({ data }) => {
                console.log('Preorder success data', data);
                if (data.redirectUrl) {
                    window.location.href = data.redirectUrl;
                } else if (this.form.payment_method === "phonepe") {
                    if(!data.success){
                        this.$notify('Something wrong, please try again');
                    }else{
                        window.location.href = data.data.instrumentResponse.redirectInfo.url;
                    }
                } else if (this.form.payment_method === "stripe") {
                    this.confirmStripePayment(data);
                } else if (this.form.payment_method === "paytm") {
                    this.confirmPaytmPayment(data);
                } else if (this.form.payment_method === "razorpay") {
                    this.confirmRazorpayPayment(data);
                } else if (this.form.payment_method === "paystack") {
                    this.confirmPaystackPayment(data);
                } else if (this.form.payment_method === "authorizenet") {
                    this.confirmAuthorizeNetPayment(data);
                } else if (this.form.payment_method === "flutterwave") {
                    this.confirmFlutterWavePayment(data);
                } else if (this.form.payment_method === "mercadopago") {
                    this.confirmMercadoPagoPayment(data);
                } else {
                    this.confirmOrder(
                        data.orderId,
                        this.form.payment_method
                    );
                }
            })
            .catch((error) => {
                console.error('placePreOrder: Error caught:', error);
                if (error.response && error.response.status === 422) {
                    this.errors.record(error.response.data.errors);
                }
                this.$notify(error.response?.data?.message || 'An error occurred while placing preorder.');
                this.placingOrder = false;
            });
        },

        renderPayPalButton() {
            let vm = this;
            let response;

            window.paypal.Buttons({
                async createOrder() {
                    try {
                        const checkoutRoute = vm.isPreorderItems ? 'preorder.checkout.create' : 'checkout.create';
                        response = await axios.post(
                            route(checkoutRoute),
                            vm.form
                        );
                        console.log('createOrder PayPal: Axios response received:', response);
                        return response.data.resourceId;
                    } catch (error) {
                        console.error('createOrder PayPal: Error caught:', error);
                        if (error.response && error.response.status === 422) {
                            vm.errors.record(error.response.data.errors);
                        }
                        vm.$notify(error.response?.data?.message || 'Failed to create PayPal order.');
                        // Re-throw to ensure PayPal flow knows it failed
                        throw error;
                    }
                },
                onApprove() {
                    vm.loadingOrderSummary = true;
                    vm.confirmOrder(
                        response.data.orderId,
                        "paypal",
                        response.data
                    );
                },
                onError() { // onError typically receives an error object, but we'll use `response` from `createOrder` as fallback
                    console.error('PayPal onError triggered.');
                    vm.deleteOrder(response?.data?.orderId); // Safely access orderId
                },
                onCancel() {
                    console.warn('PayPal onCancel triggered.');
                    vm.deleteOrder(response?.data?.orderId); // Safely access orderId
                },
            }).render("#paypal-button-container");
        },

        renderStripeElements() {
            this.stripeCardElement = this.stripe.elements().create("card", {
                hidePostalCode: true,
            });
            this.stripeCardElement.mount("#stripe-card-element");
        },

        async confirmPhonePePayment(data) {
            console.log('confirmPhonePePayment data:', data)
            const options = {
                method: 'post',
                url: data.data.instrumentResponse.redirectInfo.url,
                headers: {
                    accept: 'text/plain',
                    'Content-Type': 'application/json',
                },
            };
            axios.request(options)
                .then(function (response) {
                console.log('PhonePe Axios request response:', response.data);
                })
                .catch(function (error) {
                    console.error('PhonePe Axios request error:', error);
                });
        },

        async confirmStripePayment({ orderId, clientSecret }) {
            let result = await this.stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: this.stripeCardElement,
                    billing_details: {
                        email: this.form.customer_email,
                        name: `${this.form.billing.first_name} ${this.form.billing.last_name}`,
                        address: {
                            city: this.form.billing.city,
                            country: this.form.billing.country,
                            line1: this.form.billing.address_1,
                            line2: this.form.billing.address_2,
                            postal_code: this.form.billing.zip,
                            state: this.form.billing.state,
                        },
                    },
                },
            });

            if (result.error) {
                console.error('Stripe payment confirmation error:', result.error);
                this.placingOrder = false;
                this.stripeError = result.error.message;
                this.deleteOrder(orderId);
            } else {
                console.log('Stripe payment confirmation successful:', result);
                this.confirmOrder(orderId, "stripe", result);
            }
        },

        confirmPaytmPayment({ orderId, amount, txnToken }) {
            let config = {
                root: "",
                flow: "DEFAULT",
                data: {
                    orderId: orderId,
                    token: txnToken,
                    tokenType: "TXN_TOKEN",
                    amount: amount,
                },
                merchant: {
                    name: FleetCart.storeName,
                    redirect: false,
                },
                handler: {
                    transactionStatus: (response) => {
                        console.log('Paytm transactionStatus:', response);
                        if (response.STATUS === "TXN_SUCCESS") {
                            this.confirmOrder(orderId, "paytm", response);
                        } else if (response.STATUS === "TXN_FAILURE") {
                            this.placingOrder = false;
                            this.deleteOrder(orderId);
                        }
                        window.Paytm.CheckoutJS.close();
                    },
                    notifyMerchant: (eventName) => {
                        console.log('Paytm notifyMerchant event:', eventName);
                        if (eventName === "APP_CLOSED") {
                            this.placingOrder = false;
                            this.deleteOrder(orderId);
                        }
                    },
                },
            };

            window.Paytm.CheckoutJS.init(config)
                .then(() => {
                    console.log('Paytm CheckoutJS initialized. Invoking...');
                    window.Paytm.CheckoutJS.invoke();
                })
                .catch((error) => {
                    console.error('Paytm CheckoutJS initialization error:', error);
                    this.deleteOrder(orderId);
                });
        },

        confirmRazorpayPayment(razorpayOrder) {
            this.placingOrder = false;
            let vm = this;
            console.log('Confirming Razorpay payment:', razorpayOrder);

            new window.Razorpay({
                key: FleetCart.razorpayKeyId,
                name: FleetCart.storeName,
                description: `Payment for order #${razorpayOrder.receipt}`,
                image: FleetCart.storeLogo,
                order_id: razorpayOrder.id,
                handler(response) {
                    console.log('Razorpay handler response:', response);
                    vm.placingOrder = true;
                    vm.confirmOrder(
                        razorpayOrder.receipt,
                        "razorpay",
                        response
                    );
                },
                modal: {
                    ondismiss() {
                        console.warn('Razorpay modal dismissed.');
                        vm.deleteOrder(razorpayOrder.receipt);
                    },
                },
                prefill: {
                    name: `${vm.form.billing.first_name} ${vm.form.billing.last_name}`,
                    email: vm.form.customer_email,
                    contact: vm.form.customer_phone,
                },
            }).open();
        },

        confirmPaystackPayment({
            key,
            email,
            amount,
            ref,
            currency,
            order_id,
        }) {
            let vm = this;
            console.log('Confirming Paystack payment:', { key, email, amount, ref, currency, order_id });

            PaystackPop.setup({
                key,
                email,
                amount,
                ref,
                currency,
                onClose() {
                    console.warn('Paystack pop closed.');
                    vm.placingOrder = false;
                    vm.deleteOrder(order_id);
                },
                callback(response) {
                    console.log('Paystack callback response:', response);
                    vm.placingOrder = false;
                    vm.confirmOrder(order_id, "paystack", response);
                },
                onBankTransferConfirmationPending(response) {
                    console.log('Paystack bank transfer pending:', response);
                    vm.placingOrder = false;
                    vm.confirmOrder(order_id, "paystack", response);
                },
            }).openIframe();
        },

        confirmAuthorizeNetPayment({ token }) {
            this.authorizeNetToken = token;
            console.log('Confirming Authorize.Net payment with token:', token);
            this.$nextTick(() => {
                this.$refs.authorizeNetForm.submit();
                this.authorizeNetToken = null;
            });
        },

        confirmFlutterWavePayment({
            public_key,
            tx_ref,
            order_id,
            amount,
            currency,
            payment_options,
            redirect_url,
        }) {
            let vm = this;
            console.log('Confirming FlutterWave payment:', { public_key, tx_ref, order_id, amount, currency, payment_options, redirect_url });

            FlutterwaveCheckout({
                public_key,
                tx_ref,
                amount,
                currency,
                payment_options: payment_options.join(", "),
                redirect_url,
                customer: {
                    email: this.form.customer_email,
                    phone_number: this.form.customer_phone,
                    name: this.form.billing.full_name,
                },
                customizations: {
                    title: FleetCart.storeName,
                    logo: FleetCart.storeLogo,
                },
                onclose(incomplete) {
                    console.warn('FlutterWave checkout closed. Incomplete:', incomplete);
                    vm.placingOrder = false;
                    if (incomplete) {
                        vm.deleteOrder(order_id);
                    }
                },
            });
        },

        confirmMercadoPagoPayment(mercadoPagoOrder) {
            this.placingOrder = false;
            console.log('Confirming MercadoPago payment:', mercadoPagoOrder);

            const SUPPORTED_LOCALES = {
                en_US: "en-US",
                es_AR: "es-AR",
                es_CL: "es-CL",
                es_CO: "es-CO",
                es_MX: "es-MX",
                es_VE: "es-VE",
                es_UY: "es-UY",
                es_PE: "es-PE",
                pt_BR: "pt-BR",
            };

            const mercadoPago = new MercadoPago(mercadoPagoOrder.publicKey, {
                locale:
                    SUPPORTED_LOCALES[mercadoPagoOrder.currentLocale] ||
                    "en-US",
            });

            mercadoPago.checkout({
                preference: {
                    id: mercadoPagoOrder.preferenceId,
                },
                autoOpen: true,
            });
        },

        onChangeCheekWallet(){
            if (!this.form.check_wallet) {
                this.form.wallet = 0;
            }
            this.onChangeWallet();
        },
        resetWallet(){
            this.form.wallet = 0;
            this.form.check_wallet = false;
            this.onChangeWallet();
        },
        onChangeWallet(){
            this.loadingOrderSummary = true;
            let totalAmount = this.currentCart.subTotal?.amount + (this.currentCart.shippingCost?.amount ?? 0);

            let enteredWalletAmount = parseFloat(this.form.wallet || 0);
            let availableWalletAmount = parseFloat(this.wallet_amount || 0);

            if (enteredWalletAmount > availableWalletAmount) {
                enteredWalletAmount = availableWalletAmount;
            }
            if (enteredWalletAmount > totalAmount) {
                enteredWalletAmount = totalAmount;
            }
            if (enteredWalletAmount < 0) {
                enteredWalletAmount = 0;
            }

            this.form.wallet = enteredWalletAmount.toFixed(2);

            let newTotal = parseFloat(totalAmount - enteredWalletAmount).toFixed(2);

            if (this.currentCart.total) {
                this.currentCart.total.amount = parseFloat(newTotal);
                this.currentCart.total.formatted = `₹${newTotal}`;
                this.currentCart.total.inCurrentCurrency.amount = parseFloat(newTotal);
                this.currentCart.total.inCurrentCurrency.formatted = `₹${newTotal}`;
            }

            this.loadingOrderSummary = false;
        },
    },
};
